import React, { useState, useEffect } from "react";
import Empsidebar from "../components/Empsidebar";
import Empheader from "../components/Empheader";
import Uppercase from "../../admin/components/Uppercase";
import * as XLSX from "xlsx";
import { FaEdit, FaEye } from "react-icons/fa";
import axios from "axios";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useYearContext } from "../../admin/components/YearContext";

function Empclients() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();

  const navigate = useNavigate();
  const [clientData, setClientData] = useState([]);
  const [role, setRole] = useState("");
  const [username, setUsername] = useState("");
  useEffect(() => {
    const token = Cookies.get("token");

    if (!token) {
      navigate("/login");
    } else {
      const decoded = jwtDecode(token);
      setUsername(decoded.email);
      setRole(decoded.role);
    }
  }, []);

  const fetchClientData = async () => {
    try {
      console.log(username);
      const response = await axios.get(
        ` https://api.easytaxexperts.com/empclients/${username}`
      );
      if (response.data.success) {
        setClientData(response.data.clientsResult);
        console.log(response.data.clientsResult);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchClientData();
  }, [username]);

  const handleonExport = () => {
    // Create a new worksheet from the client data
    const worksheetData = clientData.map((doc) => {
      return {
        "Client ID": doc.client_id,
        "Client Name": doc.client_name,
        Email: doc.email,
        Contact: doc.contact,
        "Alternate Contact": doc.alternateContact,
        "Registered At": doc.registered_at,
        Status: doc.status,
        Comments: doc.comments,
      };
    });
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Client Data");
    XLSX.writeFile(workbook, "ClientData.xlsx");
  };

  //filters
  const [filters, setFilters] = useState({
    dateFrom: "",
    dateTo: "",
    clientName: "",
    status: "",
  });

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const filterDocuments = clientData.filter((doc) => {
    const { dateFrom, dateTo, clientName, status } = filters;
    const lowerCaseStatus = status.toLowerCase();
    const documentDate = doc.registered_at
      ? doc.registered_at.substring(0, 10)
      : "";
    const fromDate = dateFrom ? dateFrom : "";
    const toDate = dateTo ? dateTo : new Date().toISOString().substring(0, 10);

    const nextYear = (parseInt(yearSelected) + 1).toString();
    const startDate = `${parseInt(nextYear) - 1}-09-01`;
    const endDate = `${nextYear}-08-31`;

    return (
      documentDate >= startDate &&
      documentDate <= endDate &&
      (dateFrom === "" || documentDate >= fromDate) &&
      (dateTo === "" || documentDate <= toDate) &&
      (clientName === "" ||
        doc.client_name.toLowerCase().includes(clientName.toLowerCase())) &&
      (status === "" || doc.status.toLowerCase() === lowerCaseStatus)
    );
  });

  const reversedDocuments = filterDocuments.slice().reverse();
  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 100;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = reversedDocuments.slice(firstIndex, lastIndex);
  const npage = Math.ceil(filterDocuments.length / recordsPerPage);
  const numbers = [...Array(npage + 1).keys()].slice(1);

  const prePage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const changeCpage = (id) => {
    setCurrentPage(id);
  };
  const nextPage = () => {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const [formdata, setFormdata] = useState({
    status: "",
    comments: "",
  });

  const handleChange = (e) => {
    setFormdata((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.put(
        ` https://api.easytaxexperts.com/empeditclient/${editID}`,
        formdata
      );

      if (response && response.data && response.data.success) {
        toast.success("Client updated successfully");
        window.location.reload();

        setFormdata({
          status: "",
          comments: "",
        });
      } else {
        toast.error("Failed to update client");
      }
    } catch (error) {
      console.error("Error updating client:", error);
      toast.error("An error occurred while updating the client.");
    }
  };

  const [editID, setEditID] = useState("");
  const handleEdit = (id, status, comments) => {
    setEditID(id);
    setFormdata({
      status: status,
      comments: comments,
    });
  };

  const handleView = (email) => {
    navigate("/empclientviewdocs", { state: { clientEmail: email } });
  };

  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Pad month with leading zero
    const day = String(date.getDate()).padStart(2, "0"); // Pad day with leading zero
    const hours = String(date.getHours()).padStart(2, "0"); // Pad hours with leading zero
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Pad minutes with leading zero
    const seconds = String(date.getSeconds()).padStart(2, "0"); // Pad seconds with leading zero

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Empheader openSidebar={openSidebar} />
        <Empsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
          <div
  className="row mt-2"
  style={{
    fontSize: "12px", // Smaller text size
   
    marginBottom: "5px",
  }}
>
           <div
    className="col-lg-12 d-flex flex-wrap align-items-center gap-2"
    style={{ rowGap: "10px" }} // Adjust spacing between elements
  >
  <div>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  name="dateFrom"
                  value={filters.dateFrom}
                  onChange={handleFilterChange}
                  style={{ minWidth: "150px" }}
                />
              </div>
              <div >
                <input
                  type="date"
                  className="form-control form-control-sm"
                  name="dateTo"
                  value={filters.dateTo}
                  onChange={handleFilterChange}
                  style={{ minWidth: "150px" }}
                />
              </div>
              <div >
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Client Name"
                  name="clientName"
                  value={filters.clientName}
                  onChange={handleFilterChange}
                  style={{ minWidth: "150px", height: "30px", padding: "5px" }}
                />
              </div>
              <div >
                <select
                  className="form-select form-select-sm"
                  name="status"
                  value={filters.status}
                  onChange={handleFilterChange}
                  style={{ minWidth: "150px" }}
                >
                   <option value="" style={{ fontSize: "12px", height: "30px" }}>All Statuses</option>
    <option value="Registered" style={{ fontSize: "12px", height: "30px" }}>Registered</option>
    <option value="Callback" style={{ fontSize: "12px", height: "30px" }}>Callback</option>
    <option value="Voicemail" style={{ fontSize: "12px", height: "30px" }}>Voicemail</option>
    <option value="Wrongnumber" style={{ fontSize: "12px", height: "30px" }}>Wrong Number</option>
    <option value="Intrested" style={{ fontSize: "12px", height: "30px" }}>Interested</option>
    <option value="Not Intrested" style={{ fontSize: "12px", height: "30px" }}>Not Interested</option>
    <option value="Documentpending" style={{ fontSize: "12px", height: "30px" }}>Document Pending</option>
    <option value="Duplicate" style={{ fontSize: "12px", height: "30px" }}>Duplicate</option>
    <option value="Alreadyfiledtaxes" style={{ fontSize: "12px", height: "30px" }}>Already Filed Taxes</option>
    <option value="Documentsuploaded" style={{ fontSize: "12px", height: "30px" }}>Documents Uploaded</option>
    <option value="Preparationpending" style={{ fontSize: "12px", height: "30px" }}>Preparation Pending</option>
    <option value="Additionaldocumentpending" style={{ fontSize: "12px", height: "30px" }}>Additional Document Pending</option>
    <option value="Reviewpending" style={{ fontSize: "12px", height: "30px" }}>Review Pending</option>
    <option value="Reviewcompleted" style={{ fontSize: "12px", height: "30px" }}>Review Completed</option>
    <option value="Clientreview" style={{ fontSize: "12px", height: "30px" }}>Client Review</option>
    <option value="Paymentpending" style={{ fontSize: "12px", height: "30px" }}>Payment Pending</option>
    <option value="Paid" style={{ fontSize: "12px", height: "30px" }}>Paid</option>
    <option value="Partialpayment" style={{ fontSize: "12px", height: "30px" }}>Partial Payment</option>
    <option value="Finaldocumentsent" style={{ fontSize: "12px", height: "30px" }}>Final Document Sent</option>
    <option value="Efilingpending" style={{ fontSize: "12px", height: "30px" }}>E Filing Pending</option>
    <option value="Itindocumentssenttoclient" style={{ fontSize: "12px", height: "30px" }}>ITIN Documents Sent to Client</option>
    <option value="Itincertificationpending" style={{ fontSize: "12px", height: "30px" }}>ITIN Certification Pending</option>
    <option value="Statefilingpending" style={{ fontSize: "12px", height: "30px" }}>State Filing Pending</option>
    <option value="Filingcopypending" style={{ fontSize: "12px", height: "30px" }}>Filing Copy Pending</option>
    <option value="Filingcopyuploaded" style={{ fontSize: "12px", height: "30px" }}>Filing Copy Uploaded</option>
    <option value="Finaldrafttobeuploaded" style={{ fontSize: "12px", height: "30px" }}>Final Draft to be Uploaded</option>
    <option value="Signature8879senttoclient" style={{ fontSize: "12px", height: "30px" }}>Signature 8879 Sent to Client</option>
    <option value="Signature8879signedcopyreceived" style={{ fontSize: "12px", height: "30px" }}>Signature 8879 Signed copy Received</option>
    <option value="Signature8879yettoreceive" style={{ fontSize: "12px", height: "30px" }}>Signature 8879 Yet to Receive</option>
    <option value="Complete" style={{ fontSize: "12px", height: "30px" }}>Completed</option>
                </select>
              </div>
            </div>
            </div>

            <div
  className="table-container"
  style={{
    height: "calc(89vh - 150px)", // Adjust the 150px based on your header/pagination height
   
    border: "1px solid #ccc",
  }}
>
            <div className="table-responsive tablediv">
            <table
      className="table table-hover table-bordered"
      style={{
        fontSize: "12px", // Smaller font size
        lineHeight: "1.2", // Reduce line height for compact view
      }}
    >
                <thead className="table-primary">
                  <tr>
                  <th style={{ padding: "5px" }}>S.No</th>
                  <th style={{ padding: "5px" }}>Client ID</th>
                  <th style={{ padding: "5px" }}>Client Name</th>
                  <th style={{ padding: "5px" }}>Email</th>
                  <th style={{ padding: "5px" }}>Contact</th>
                  <th style={{ padding: "5px" }}>Alternate Contact</th>

                  <th style={{ padding: "5px" }}>Registered At</th>
                  <th style={{ padding: "5px" }}>Status</th>
                  <th style={{ padding: "5px" }}>Comments</th>
                  <th style={{ padding: "5px" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {records.map((doc, index) => {
                    return (
                      <tr key={doc.id}>
                      <td style={{ padding: "5px" }}>
                {filterDocuments.length -
                  ((currentPage - 1) * recordsPerPage +
                  index)}
              </td>
              <td style={{ padding: "5px" }}>{doc.client_id}</td>
              <td style={{ padding: "5px" }}>{doc.client_name}</td>
              <td style={{ padding: "5px" }}>{doc.email}</td>
              <td style={{ padding: "5px" }}>{doc.contact}</td>
              <td style={{ padding: "5px" }}>{doc.alternateContact}</td>

              <td style={{ padding: "5px" }}>{formatDateTime(doc.registered_at)}</td>
              <td style={{ padding: "5px" }}>{doc.status}</td>
              <td style={{ padding: "5px" }}>{doc.comments}</td>

              <td style={{ padding: "5px" }} className="d-flex gap-1">
                          <button
                            className="btn btn-info btn-sm"
                            onClick={() => handleView(doc.email)}
                          >
                            <FaEye />
                          </button>
                          <button
                            className="btn btn-warning btn-sm"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                          >
                            <FaEdit
                              onClick={() =>
                                handleEdit(doc.id, doc.status, doc.comments)
                              }
                            />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            </div>

            <div
              class="modal fade"
              id="exampleModal"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Edit Client
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <div class="modal-body">
                      <div className="row gap-2 align-items-center">
                        <label htmlFor="status" className="col-lg-2">
                          Status
                        </label>
                        <div className="col-lg-6">
                          <select
                            className="form-select "
                            onChange={handleChange}
                            name="status"
                            value={formdata.status}
                          >
                            
                            <option value="Registered">Registered</option>
                            <option value="Callback">Callback</option>
                            <option value="Voicemail">Voicemail</option>
                            <option value="Wrongnumber">Wrong Number</option>
                            <option value="Intrested">Intrested</option>
                            <option value="Not Intrested">Not Intrested</option>
                            <option value="Documentpending">
                              Document Pending
                            </option>
                            <option value="Duplicate">Duplicate</option>
                            <option value="Alreadyfiledtaxes">
                             Already Filed Taxes
                            </option>
                            <option value="Documentsuploaded">
                              Documents Uploaded{" "}
                            </option>
                            <option value="Preparationpending">
                              Preparation Pending
                            </option>
                            <option value="Additionaldocumentpending">
                              Additional Document Pending
                            </option>
                            <option value="Reviewpending">
                              Review Pending
                            </option>
                            <option value="Reviewcompleted">
                              Review Completed
                            </option>
                            <option value="Clientreview">Client Review</option>
                            <option value="Paymentpending">
                              Payment Pending
                            </option>
                            <option value="Paid">paid</option>
                            <option value="Partialpayment">
                              Partial Payment
                            </option>
                            <option value="Finaldocumentsent">
                              Final Document Sent
                            </option>
                            <option value="Efilingpending">
                              E filing Pending
                            </option>
                            <option value="Itndocumentssenttoclient">
                              ITIN Documents Sent to Client
                            </option>
                            <option value="Itncertificationpending">
                              ITIN Certification Pending{" "}
                            </option>
                            <option value="Statefilingpending">
                              State filing Pending{" "}
                            </option>
                            <option value="Filingcopypending">
                              Filing Copy Pending{" "}
                            </option>
                            <option value="Filingcopyuploaded">
                              Filing Copy Uploaded
                            </option>
                            <option value="Finaldrafttobeuploaded">
                              Final Draft to be Uploaded
                            </option>
                            <option value="Signature8879senttoclient">
                              Signature 8879_Sent to Client
                            </option>
                            <option value="Signature8879signedcopyreceived">
                              Signature 8879_Signed copy Received
                            </option>
                            <option value="Signature8879yettoreceive">
                              Signature 8879_Yet to Receive
                            </option>
                            <option value="Complete">Completed</option>
                          </select>
                        </div>
                      </div>
                      <div className="row gap-2 align-items-center mt-2">
                        <label htmlFor="comments" className="col-lg-2">
                          Comments
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="text"
                            className="form-control"
                            name="comments"
                            value={formdata.comments}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                      >
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <nav className="mt-2">
            <ul
    className="pagination"
    style={{
      fontSize: "10px", // Reduce font size
      padding: "0", // Remove unnecessary padding
    }}
  >
                <li className="page-item">
                <a
        href="#"
        className="page-link"
        onClick={prePage}
        style={{
          padding: "2px 5px", // Adjust padding for smaller height
          height: "auto", // Allow height to adjust with padding
          fontSize: "12px",
        }}
      >
                    Prev
                  </a>
                </li>
                {numbers.map((n, i) => {
                  return (
                    <li
                      className={`page-item ${
                        currentPage === n ? "active" : ""
                      }`}
                      key={i}
                    >
                       <a
            href="#"
            className="page-link"
            onClick={() => changeCpage(n)}
            style={{
              padding: "2px 5px", // Reduce padding
              height: "auto", // Consistent height
              fontSize: "12px",
            }}
          >
                        {n}
                      </a>
                    </li>
                  );
                })}
                <li className="page-item">
                <a
        href="#"
        className="page-link"
        onClick={nextPage}
        style={{
          padding: "2px 5px", // Same padding as above
          height: "auto", // Adjust height
          fontSize: "12px",
        }}
      >
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Empclients;
